import { exportProjectPdf } from '../../exportProjectPdf';
import type { ExportFormat } from '../types';

// Wraps the existing exportProjectPdf (the original "Export PDF" button)
// in the registry-format shape. The exporter itself is unchanged — this
// file is just the format descriptor + a thin adapter that picks the
// fields exportProjectPdf wants out of the shared ExportProjectData.
export const basicPdfFormat: ExportFormat = {
  id: 'basic-pdf',
  label: 'Basic Format',
  fileFormat: 'PDF',
  description: 'Clean, printer-friendly report of the whole project.',
  run: async (data) => {
    await exportProjectPdf({
      name: data.name,
      trackerId: data.trackerId,
      description: data.description,
      overallHealth: data.overallHealth,
      startDate: data.startDate,
      endDate: data.endDate,
      completionPercentage: data.completionPercentage,
      executiveSummary: data.executiveSummary,
      milestones: data.milestones,
      risks: data.risks,
      kpis: data.kpis,
      tasks: data.tasks,
      accomplishments: data.accomplishments,
      priorities: data.priorities,
    });
  },
};
